module.exports = __webpack_public_path__ + "img/Frame-28.a3992d26.svg";